import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { MobileSession, Session } from '@features/Session';
import { buildCramPath, buildUnitPath, paths, type WordsReturnState } from '@shared/config';
import { ToastContainer } from '@shared/ui';
import { useIsSidebarMobile } from '@widgets/Sidebar';

export default function SessionPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const state = location.state as { fromModuleId?: string; fromDashboard?: boolean; fromWords?: boolean } | null;
  const moduleId = searchParams.get('moduleId') || state?.fromModuleId;
  const fromDashboard = state?.fromDashboard ?? false;
  // «Тренировать новые» на «Словах и модулях» — туда и обратно (2026-10-28).
  const back = state?.fromWords ? paths.words : fromDashboard ? paths.dashboard : null;
  const isMobile = useIsSidebarMobile();

  if (!moduleId) return <Navigate to={paths.training} replace />;

  // На «Слова и модули» — с тем же модулем, а не с первым.
  const backState: WordsReturnState | undefined = back === paths.words ? { wordsModuleId: moduleId } : undefined;
  const onExit = () => navigate(back ?? buildUnitPath(moduleId), { state: backState });
  const onFinish = () => navigate(back ?? buildCramPath(moduleId), { state: backState });
  // Тренировка — вне оболочки приложения, а тосты (жетоны за серию и «Задание дня») нужны прямо здесь, на итогах.
  return (
    <>
      {isMobile ? (
        <MobileSession key={moduleId} onExit={onExit} cram moduleId={moduleId} onFinish={onFinish} />
      ) : (
        <Session key={moduleId} onExit={onExit} cram moduleId={moduleId} onFinish={onFinish} />
      )}
      <ToastContainer />
    </>
  );
}
